// Capitalize gateway brand but keep "BSC" in upper case if present
const gatewayBrand = value => {
  const capitalize = v => v.charAt(0).toUpperCase() + v.slice(1).toLowerCase()

  if (!value) return ''
  value = value.toString()

  // Check if "BSC" present
  if (value.indexOf('BSC ') !== -1) {
    return 'BSC ' + capitalize(value.split('BSC ')[1])
  }

  return capitalize(value)
}

export default gatewayBrand
